import { buildUrl, getSlugFromPage } from '@eliadmin/core/src/utils/url-utils';

/**
 * Be sure to never statically call the function that returns the route.
 * Always call it onDemand while rendering, se we are sure the getSlugFromPage returns correct slug.
 * This is made like this because we are dependant on globalStore inside client components and react cache inside RSC.
 */
export const ROUTES_OVERRIDES = {
  // profile
  PROFILE: () => getSlugFromPage('profile'),
  FAVORITES: () => getSlugFromPage('profile.favorites'),
  ORDERS: () => getSlugFromPage('profile.orders'),
  ORDER_CONFIRM: () => getSlugFromPage('order-confirm'),
  LOYALTY_PROGRAM: () => getSlugFromPage('profile.loyalty-program'),
  RETURN: () => getSlugFromPage('profile.return'),
  RETURNS: () => getSlugFromPage('profile.return'),
  CHANGE_PASSWORD: () => getSlugFromPage('profile.change-password'),
  SIGN_OUT: () => '/api/sign-out',

  // auth
  SIGN_IN: (returnUrl?: string) =>
    `${buildUrl(getSlugFromPage('sign-in'), { search: { returnUrl } })}`,
  REGISTER: (returnUrl?: string) =>
    `${buildUrl(getSlugFromPage('register'), { search: { returnUrl } })}`,
  PASSWORD_RESET: () => getSlugFromPage('password-reset'),
  RESET_PASSWORD: () => getSlugFromPage('reset-password'),

  // cart
  CART: () => getSlugFromPage('cart'),

  // categories
  CATEGORIES: () => getSlugFromPage('categories'),
  CATEGORY: ({ slug, page }: { slug: string; page?: number }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug }, search: { page } })}`,

  // products
  PRODUCT: ({ slug }: { slug: string }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug } })}`,

  ADVISORY: (aCategory?: string, page?: string) =>
    buildUrl(getSlugFromPage('advisory'), { search: { aCategory, page } }),

  // blog
  BLOG_DETAIL: ({ slug }: { slug: string }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug } })}`,
  BLOG: () => `${getSlugFromPage('blog')}`,

  // search
  SEARCH: (search?: string) => `${buildUrl(getSlugFromPage('search'), { search: { search } })}`,
  SEARCH_ADVANCED: (search?: string) =>
    `${buildUrl(getSlugFromPage('search-advanced'), { search: { search } })}`,

  // manufacturers
  // TODO: add page manufacturers
  // MANUFACTURERS: () => `${getSlugFromPage('manufacturer.[slug]')}`,

  MANUFACTURER: ({ slug, page }: { slug: string; page?: number }) =>
    `${buildUrl(getSlugFromPage('manufacturer.[slug]'), { params: { slug }, search: { page } })}`,

  DYNAMIC: ({ slug, page }: { slug: string; page?: number }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug }, search: { page } })}`,

  // general
  HOME: () => getSlugFromPage('home'),
  CONTACT: () => getSlugFromPage('contact'),

  // newsletter
  NEWSLETTER_CONFIRM: () => getSlugFromPage('newsletter-confirm'),

  // tag
  TAG: ({ slug, page }: { slug: string; page?: number }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug }, search: { page } })}`,

  SUPPLIER: ({ slug, page }: { slug: string; page?: number }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug }, search: { page } })}`,

  // pharmacy
  RECIEPT_RESERVATION: () => getSlugFromPage('reciept-reservation'),
  CHECK_AVAILABILITY: () => getSlugFromPage('availability-check'),

  // jobportal
  CURRICULUM_CREATE: () => getSlugFromPage('jobportal.create-curriculum'),
  JOB_OFFERS: () => getSlugFromPage('jobportal.offers'),
  JOB_APPLY: ({ slug }: { slug: string }) =>
    `${buildUrl(getSlugFromPage('jobportal.apply'), { params: { slug } })}`,

  // reservation
  RESERVATION: () => getSlugFromPage('reservation'),
  RESERVATION_CONFIRM: () => getSlugFromPage('reservation-confirm'),

  GDPR: () => getSlugFromPage('gdpr'),
  TOS: () => getSlugFromPage('tos'),

  // references
  REFERENCES: () => getSlugFromPage('references'),
  REFERENCE: ({ slug }: { slug: string }) =>
    `${buildUrl(getSlugFromPage('slug'), { params: { slug } })}`,

  SERVICES: () => getSlugFromPage('services'),

  FAVORITE_PRODUCTS: () => getSlugFromPage('favorite-products'),
  ORDER_STATUS: () => getSlugFromPage('order-status'),
};
